<ng-container [ngSwitch]="headingLevel">
  <h1
    *ngSwitchCase="1"
    [attr.data-test-id]="testId"
    class="heading--base heading--title-{{
      titleLevel
    }} heading--spacingBottom-{{ spacingBottom }}"
  >
    <ng-container *ngTemplateOutlet="headingTemplate"></ng-container>
  </h1>
  <h2
    *ngSwitchCase="2"
    [attr.data-test-id]="testId"
    class="heading--base heading--title-{{
      titleLevel
    }} heading--spacingBottom-{{ spacingBottom }}"
  >
    <ng-container *ngTemplateOutlet="headingTemplate"></ng-container>
  </h2>
</ng-container>

<ng-template #headingTemplate>
  <ng-content></ng-content>
</ng-template>
